import { createMockCreator } from '@csp/test-common-utils';
import { Domain } from '../Domain';
import { StudyDocumentsFile } from '../StudyDocumentsFile';

const studyDocumentsFileMock: StudyDocumentsFile = {
  createdAt: {
    unixTimeMillis: 1714379486428,
    zone: 'UTC',
  },
  eventId: '7363271810340619523',
  id: '662f5adee011c168b846bb0d',
  isTrash: false,
  name: 'study-protocol.pdf',
  orgIds: ['60532c465129c3377998b69a'],
  roles: [],
  version: '1.5',
  domains: [Domain.PATIENT_STUDY_JOURNEY],
};

export const createStudyDocumentsFileMock = createMockCreator(studyDocumentsFileMock);
